import React, { useState, useEffect } from "react";
import { ReactNotifications, Store } from 'react-notifications-component'
import { addnotes, getnotes } from "../../../Api/prescriptionApis"
import { getCurrentUser } from "../../../Api/auth";
import { Spinner } from "react-bootstrap";


function TabNotesData({ project_id }) {

    const [notesdata, setnotesData] = useState([]);
    const [notes, setnotes] = useState('')
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [user_id, setUser_id] = useState(0);
    const [showerror, setShowererror] = useState(false);


    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUser_id(getCurrentUserdata.user._id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const handleaddnotes = () => {
        setApicall(true);

        if (notes === "") {
            // Store.addNotification({
            //     title: "Error",
            //     message: "Please enter notes",
            //     type: "danger",
            //     insert: "top",
            //     container: "top-right",
            //     animationIn: ["animated", "fadeIn"],
            //     animationOut: ["animated", "fadeOut"],
            //     dismiss: {
            //         duration: 3000,
            //         onScreen: true
            //     }
            // });
            // alert("Please enter notes");
            setShowererror(true);
            setApicall(false);
            return false;
        }

        const data = {
            notes: notes,
            user_id: user_id,
            project_id: project_id
        }

        addnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleShow();
                handlegetnotes();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setShowererror(false);
            setApicall(false);
            setValidated(true);
            setnotes('');
        });
    };

    const handlegetnotes = () => { 
        const data = {
            project_id: project_id
        } 
        getnotes(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setnotesData(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => { 
            setValidated(true);
        });
    };


    useEffect(() => {
        handlegetnotes()
    }, [project_id])


    return (
        <>
            <div className="tab-box-section notes-tab">
                <div className="form-group">
                    <textarea value={notes} onChange={(e) => setnotes(e.target.value)} className="dashboard-text-area" id="exampleFormControlTextarea1" rows="10" placeholder="Leave your note here..." ></textarea>
                    {
                        showerror && <div className="error-msg " style={{ color: 'red' }}>Please enter notes</div>
                    }
                </div>
                <div className='text-center'>
                    <button className="btn btn-create" onClick={handleaddnotes}>{apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Add Note</span>)}</button>
                </div>
            </div>
            <>
                {
                    notesdata.length === 0 ? (
                        <div className="tab-box-section notes-tab mt-4">
                            <div className='no-data-img'>
                                <img src={require("../../../assets/images/logo_text.png")} alt="" />
                            </div>
                            <div className="no-data-text">
                                <h3>No data Found</h3>
                            </div>
                        </div>
                    )
                        :
                        notesdata.map((item, i) => {
                            return (
                                <div className="dashboard-sec new_activity">
                                    <div className="tab-box-section activity-form-box">
                                        <div className="form-list-inner">
                                            <div className="form-list-title activity-title">
                                                <div className="emp-name">
                                                    <div className="emp-light">Employee:</div>
                                                    <div className="emp-bold">{item ? item.customer : ''}</div>
                                                </div>
                                            </div>
                                            <div className="form-card-body-status">
                                            {item.notes}
                                            </div>
                                            <div className="form-change-date">Date: <span className="emp-bold">{item && formatDate(item.createdAt)}</span></div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                }
            </>
        </>
    );
}

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};

export default TabNotesData;